

<template>
	<section class="clearfix">
		<compWrapper :title="$t('fbb.accountmanage.auth_menu', { defaultValue: '权限菜单' })" theme="primary" class="pull-left width-45per">
			<componentNode class="margin-left-15 margin-top-15" @on-data="getNodeData" ref="nodedata"/>
		</compWrapper>
		<Affix :offsetTop="60">
			<compWrapper :title="$t('global.common.base_information', { defaultValue: '基本信息' })" theme="primary" class="pull-right width-50per">
                <!-- 一级分类 -->
                <div class="margin-20" v-if="showlevel1">
                    <vForm :labelWidth="120">
                        <compFormEdit :formdata="getOne" v-model="formData" ref="formone" class="margin-15"></compFormEdit>
                    </vForm>
                </div>
                <!-- 二级分类 -->
                <div class="margin-20" v-if="showlevel2">
                    <vForm :labelWidth="120">
                        <compFormEdit :formdata="getTwo" v-model="formData" ref="formtwo" class="margin-15"></compFormEdit>
                    </vForm>
                </div>
                <!-- 三级分类 -->
                <div class="margin-20" v-if="showlevel3">
                    <vForm :labelWidth="120">
                        <compFormEdit :formdata="getThree" v-model="formData" ref="formthree" class="margin-15"></compFormEdit>
                    </vForm>
                </div>
                
				<footer class="text-center" v-if="operateType=='add'||operateType=='edit'">
					<vButton theme="primary" @click="updateMenu" class="margin-right-15">{{$t('global.common.save', { defaultValue: '保存' })}}</vButton>
					<vButton @click="cancel">{{$t('global.common.reset', { defaultValue: '重置' })}}</vButton>
				</footer>
			</compWrapper>
		</Affix>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</section>
</template>

<script>
import componentNode from './node';
import { HttpGetCategory,HttpGetCategoryNewCode,HttpSaveCategoryOne } from '@/service/billing';
import { mapGetters } from 'vuex';
export default {
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormEdit: () => import("@components/templates/formedit"),
		componentNode,
	},
	data() {
		return {
			isSystem: false,
			loading: false,
			systemData: [],
			modelsData: [],
			operateType: '',
            formData: {},
            showlevel1:false,
            showlevel2:false,
            showlevel3:false,
            level:0,
            orderOneTypes:[
                {value:'1',label: this.$t('fbb.accountmanage.b2c_outbound', { defaultValue: 'B2C出库单' })},
                {value:'2',label: this.$t('fbb.allotmant.inbound', { defaultValue: '调拨出库单'} )},
                {value:'3',label: this.$t('fbb.accountmanage.back_inbound', { defaultValue: '退货入库单'} )},
                {value:'5',label: this.$t('fbb.accountmage.inbound_paper_box', { defaultValue: '入库单(纸箱)'} )},
                {value:'6',label: this.$t('fbb.accountmanage.inbound_container', { defaultValue: '入库单(集装箱)'} )},
                {value:'7',label: this.$t('fbb.accountmanage.inbound_other', { defaultValue: '入库单(其他)'} )},
                {value:'9',label: this.$t('fbb.accountmanage.inbound_transfer_container', { defaultValue: '中转入库执行单(集装箱)' })},
                {value:'10',label: this.$t('fbb.accountmanage.inbound_transfer_paper_box', { defaultValue: '中转入库执行单(纸箱)' })},
                {value:'11',label: this.$t('fbb.accountmanage.outbound_order', { defaultValue: '中转出库执行单' })},
                {value:'12',label: this.$t('fbb.accountmanage.b2c_outbound_cancel_order', { defaultValue: 'B2C出库取消单' })},
                {value:'14',label: this.$t('fbb.allotmant.outbound', { defaultValue: '调拨入库单' })},
                {value:'15',label: this.$t('fbb.accountmanage.inbound_order_onsite', { defaultValue: '调拨入库单(onsite)' })},
                {value:'16',label: this.$t('fbb.accountmanage.outbound_order_onsite', { defaultValue: '调拨出库单(onsite)' })},
                {value:'19',label: this.$t('fbb.accountmanage.no_source_inbound', { defaultValue: '无来源入库' })},
                {value:'20',label: this.$t('fbb.accountmanage.destory_order', { defaultValue: '销毁单' })},
            ],
            billingUnit:[
                {value:'1',label: this.$t('fbb.accountmanage.single_dan', { defaultValue: '单' })},
                {value:'2',label: this.$t('fbb.accountmanage.single_xiang', { defaultValue: '箱' })},
                {value:'3',label: this.$t('fbb.accountmanage.single_jian', { defaultValue: '件' })},
                {value:'4',label: this.$t('fbb.accountmanage.single_container', { defaultValue: '集装箱' })},
                {value:'5',label: this.$t('fbb.accountmanage.tray_bar', { defaultValue: '托盘' })},
                {value:'6',label: this.$t('fbb.accountmanage.amount', { defaultValue: '数量' })},
                {value:'7',label: this.$t('fbb.accountmanage.volumn', { defaultValue: '体积' })},
            ],
            billingSymble:{
                '1':[
                        {value:'5',label: this.$t('fbb.accountmanage.fixed_value', { defaultValue: '固定值' })},
                        {value:'7',label: this.$t('fbb.accountmanage.express_type', { defaultValue: '快递类型' })},
                        {value:'6',label: this.$t('fbb.accountmanage.send_time_effect', { defaultValue: '发货时效' })},
                        {value:'8',label: this.$t('fbb.accountmanage.special', { defaultValue: '特殊' })},
                    ],
                '2':[
                        {value:'2',label:`${this.$t('fbb.accountmanage.box_weight', { defaultValue: '箱重' })}(lb)`},
                    ],
                '3':[
                        {value:'3',label: `${this.$t('fbb.accountmanage.sku_weight', { defaultValue: 'SKU重量' })}(lb)`},
                    ],
                '4':[
                        {value:'4',label: this.$t('fbb.accountmanage.container_type', { defaultValue: '集装箱型' })},
                    ],
                '5':[
                        {value:'5',label: this.$t('fbb.accountmanage.fixed_value', { defaultValue: '固定值' })},
                    ],
                '6':[
                        {value:'5',label:this.$t('fbb.accountmanage.fixed_value', { defaultValue: '固定值' })},
                        {value:'9',label: this.$t('fbb.accountmanage.label_amount', { defaultValue: 'Label数量' })},
                    ],
                '7':[
                        {value:'10',label: this.$t('fbb.accountmanage.sku_volumn', { defaultValue: 'sku 体积' })},
                    ],
            },
            valueRange:{
                '3':[
                        {value:'1',label:'Small Standard-Size'},
                        {value:'2',label:'Large Standard-Size'},
                        {value:'3',label:'Small Oversize'},
                        {value:'4',label:'Medium Oversize'},
                        {value:'5',label:'Large Oversize'},
                        {value:'6',label:'Special Oversize'},
                    ],
                '4':[
                        {value:'1',label:'20GP'},
                        {value:'2',label:'40GP'},
                        {value:'3',label:'40HQ'},
                        {value:'4',label:'45HQ'},
                    ],
                '6':[
                        {value:'1',label: this.$t('fbb.accountmanage.24_hours', { defaultValue: '24小时' })},
                        {value:'2',label: this.$t('fbb.accountmanage.48_hours', { defaultValue: '48小时' })},
                        {value:'3',label: this.$t('fbb.accountmanage.48_hours_mt', { defaultValue: '48小时以上' })},
                    ],
                '7':[
                        {value:'1',label: this.$t('fbb.accountmanage.truck', { defaultValue: '卡车' })},
                        {value:'2',label: this.$t('fbb.accountmanage.express', { defaultValue: '快递' })},
                    ],
            },
		};
	},
	computed: {
		getOne(){
            return[
                {
                    label: this.$t('fbb.accountmanage.one_level_type_code', { defaultValue: '一级分类代码' }),
                    key: 'code',
                    span:24,
                    query:true
                }, {
                    label: this.$t('fbb.accountmanage.cost_order_type', { defaultValue: '计费单据类型' }),
                    key: 'type',
                    tag: 'vSelect',
                    options:this.orderOneTypes,
                    query:this.operateType=='edit',
                    span:24,
                }, {
                    label: this.$t('fbb.accountmanage.one_level_type_name', { defaultValue: '一级分类名称' }),
                    key: 'name',
                    tag: 'vInput',
                    span:24,
                },{
                    label: this.$t('fbb.accountmanage.description', { defaultValue: '描述' }),
                    key: 'description',
                    tag: 'vTextarea',
                    span:24,
                    required:false,
                },
            ]
        },
        getTwo(){
            return[
                {
                    label: this.$t('fbb.accountmanage.two_level_type_code', { defaultValue: '二级分类代码' }),
                    key: 'code',
                    span:24,
                    query:true
                }, {
                    label: this.$t('fbb.accountmanage.two_level_type_name', { defaultValue: '二级分类名称' }),
                    key: 'name',
                    span:24,
                },
                {
                    label: this.$t('fbb.accountmanage.is_must_cost', { defaultValue: '是否必须计费' }),
                    key: 'mustCharge',
                    tag: 'vRadio',
                    span:24,
                    options:[
                        {
                            trueValue: 1,
                            label: this.$t('global.common.choose_yes', { defaultValue: '是' })
                        }, {
                            trueValue: 0,
                            label: this.$t('global.common.choose_no', { defaultValue: '否' })
                        }
                    ]
                }, {
                    label: this.$t('fbb.accountmanage.cost_unit', { defaultValue: '计费单位' }),
                    key: 'unit',
                    tag: 'vSelect',
                    span:24,
                    options: this.billingUnit,
                    query:this.operateType=='edit',
                },
                {
                    label: this.$t('fbb.accountmanage.cost_mark', { defaultValue: '计费值标识' }),
                    key: 'valueLabel',
                    tag: 'vSelect',
                    span:24,
                    options: this.billingSymble[this.formData.unit],
                    query:this.operateType=='edit',
                },
                {
                    label: this.$t('fbb.accountmanage.description', { defaultValue: '描述' }),
                    key: 'description',
                    tag: 'vTextarea',
                    span:24,
                },
            ]
        },
        getThree(){
            // value1如果没有就设为null
            if ((this.formData.value1 !== 0 && !this.formData.value1) || !this.formData.valueOperater1) {
                this.formData.value1 = null;
            }
            return[
                {
                    label: this.$t('fbb.accountmanage.three_level_type_code', { defaultValue: '三级分类代码' }),
                    key: 'code',
                    span:24,
                    query:true
                }, {
                    label: this.$t('fbb.accountmanage.three_level_type_name', { defaultValue: '三级分类名称' }),
                    key: 'name',
                    span:24,
                }, 
                {
                    label: this.$t('global.common.status', { defaultValue: '状态' }),
                    key: 'status',
                    span:24,
                    tag: 'vRadio',
                    options:[
                        {
                            trueValue: 0,
                            label: this.$t('fbb.accountmanage.active', { defaultValue: '启用' })
                        }, {
                            trueValue: 1,
                            label: this.$t('fbb.accountmanage.disable', { defaultValue: '禁用' })
                        }
                    ]
                },
                {
                    label: this.$t('fbb.accountmanage.cost_unit', { defaultValue: '计费单位' }),
                    key: 'unit',
                    span:24,
                    options: this.billingUnit,
                    query:true
                },
                {
                    label: this.$t('fbb.accountmanage.cost_mark', { defaultValue: '计费值标识' }),
                    key: 'valueLabel',
                    span:24,
                    options: this.billingSymble[this.formData.unit],
                    query:true
                },
                // 取值范围
                {
                    label: this.$t('fbb.accountmanage.value_range', { defaultValue: '取值范围' }),
                    tag: 'vSelect',
                    key:'value',
                    options:this.valueRange[this.formData.valueLabel],
                    span:this.formData.valueLabel==4 || this.formData.valueLabel==6 ||this.formData.valueLabel==7 ? 24 : 0
                },
                // 取值大于
                {
                    label: this.$t('fbb.accountmanage.value_range', { defaultValue: '取值范围' }),
                    tag: 'vSelect',
                    key:'valueOperater',
                    span:this.formData.valueLabel==2 || this.formData.valueLabel==3 ? 8 : 0,
                    options:[
                        {
                            label:'>',
                            value:'>'
                        },
                        {
                            label:'>=',
                            value:'>='
                        },
                        {
                            label:'=',
                            value:'='
                        }
                    ],
                },
                {
                    key: 'value',
                    tag:'vInput',
                    labelWidth: 0,
                    span:this.formData.valueLabel==2 || this.formData.valueLabel==3 ? 16 : 0,
                },
                // 取值小于
                {
                    label: this.$t('fbb.accountmanage.value_range', { defaultValue: '取值范围' }),
                    tag: 'vSelect',
                    key:'valueOperater1',
                    show:this.formData.valueOperater != '=',
                    span:this.formData.valueLabel==2 || this.formData.valueLabel==3 ? 8 : 0,
                    options:[
                        {
                            label:'<',
                            value:'<'
                        },
                        {
                            label:'<=',
                            value:'<='
                        },
                    ],
                },
                {
                    key: 'value1',
                    tag:'vInput',
                    labelWidth: 0,
                    show:this.formData.valueOperater != '=',
                    span:this.formData.valueLabel==2 || this.formData.valueLabel==3 ? 16 : 0,
                },
                {
                    label: this.$t('fbb.accountmanage.description', { defaultValue: '描述' }),
                    key: 'description',
                    tag: 'vTextarea',
                    span:24,
                },
            ]
        }
	},
	created() {

	},

	methods: {
		cancel() {
			this.formData = {};
			this.$refs.form.resetFields();
		},
		// ...mapActions('ucadm',['actionBase']),
		getNodeData(data = {}, edittype) {
            if(edittype=="add"){
                let { code,type,mustCharge,unit,valueLabel,status,valueOperater,value,valueOperater1,value1 } = data;
            this.formData = { code,type,mustCharge,unit,valueLabel,status,valueOperater,value,valueOperater1,value1 }
                switch(data.level){
                    case 0:
                        this.showlevel1 = true;
                        this.showlevel2 = false;
                        this.showlevel3 = false;
                    break;
                    case 1: 
                        this.showlevel1 = false;
                        this.showlevel2 = true;
                        this.showlevel3 = false;
                    break;
                    case 2: 
                        this.showlevel1 = false;
                        this.showlevel2 = false;
                        this.showlevel3 = true;
                    break;
                }
            }else{
                let { code,type,name,description,mustCharge,unit,valueLabel,status,valueOperater,value,valueOperater1,value1,parentId } = data;
                this.formData = { code,type,name,description,mustCharge,unit,valueLabel,status,valueOperater,value,valueOperater1,value1,parentId }
                switch(data.level){
                    case 1:
                        this.showlevel1 = true;
                        this.showlevel2 = false;
                        this.showlevel3 = false;
                    break;
                    case 2: 
                        this.showlevel1 = false;
                        this.showlevel2 = true;
                        this.showlevel3 = false;
                    break;
                    case 3: 
                        this.showlevel1 = false;
                        this.showlevel2 = false;
                        this.showlevel3 = true;
                    break;
                }
            }
            this.operateType = edittype;
			if (edittype === 'add') {
                this.level = parseInt(data.level+1)
                this.formData.parentId = data.id
                this.getnewCode(data.id)
                return
            };
			if (edittype === 'edit') {
                console.log(data)
                this.formData.id = data.id;
                this.level = data.level
			}
        },
        getnewCode(parentId){
            HttpGetCategoryNewCode({
                parentId:parentId
            }).then(res=>{
                this.formData.code = res.data
            },err=>{
                this.$VMessage.error(err.message);
            })
        },
		async updateMenu() {
            if(this.showlevel1 == true){
                let vaild1 = await this.$refs.formone.validate();
                if (!vaild1) return;
            }
            if(this.showlevel2 == true){
                let vaild2 = await this.$refs.formtwo.validate();
                if (!vaild2) return;
            }
            if(this.showlevel3 == true){
                let vaild3 = await this.$refs.formthree.validate();
                if (!vaild3) return;
            }
            this.loading = true;
            this.formData.level = this.level
            await HttpSaveCategoryOne(this.formData).then(res=>{
                this.$VMessage.success(res.message);
                // this.$store.dispatch('dictionary/actionBillcategory',true)
                this.$refs.nodedata.getDetail()
            },err=>{
                this.$VMessage.error(err.message);
            })
            
			this.loading = false;
		},
	},
};
</script>
